<template>
  <div>
    <div v-if="value === null">
      <label class="am-unset-switch">
        <input type="checkbox">
        <div class="am-unset-slider round" @click="value = yesValue"></div>
      </label>
    </div>
    <div v-if="value !== null">
      <label class="am-switch">
        <input type="checkbox" v-bind:value="value" :checked="value === yesValue" v-on:change="onChange">
        <div class="am-slider round">
          <span class="am-switch-yes">{{ yesText }}</span>
          <span class="am-switch-no">{{ noText }}</span>
        </div>
      </label>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LiteSwitch',
  props: {
    value: {
      default: null
    },
    yesValue: {
      default: 1
    },
    noValue: {
      default: 0
    },
    yesText: {
      default: 'Yes'
    },
    noText: {
      default: 'No'
    }
  },
  methods: {
    onChange: function ($event) {
      this.$emit('input', $event.target.checked ? this.yesValue : this.noValue)
    }
  },
}
</script>

<style scoped>
  .am-switch {
    top: 3px;
    position: relative;
    display: inline-block;
    width: 50px;
    height: 20px;
    border: 1.5px solid #666666;
    border-radius: 30px;
  }

  .am-switch input {
    display: none;
  }

  .am-slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #d14747;
    -webkit-transition: 0.4s;
    transition: 0.4s;
  }

  .am-slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    bottom: 1px;
    left: 3px;
    background-color: white;
    border: 1px solid #666666;
    border-radius: 30px;
    -moz-transition: all 0.3s linear; -webkit-transition: all 0.3s linear;
    -o-transition: all 0.3s linear; transition: all 0.3s linear;
  }

  .am-switch input:checked + .am-slider {
    background-color: #34D97B;
  }

  .am-switch input:focus + .am-slider {
    box-shadow: 0 0 1px #101010;
  }

  .am-switch input:checked + .am-slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
  }

  .am-slider.round {
    border-radius: 34px;
  }

  .am-slider.round:before {
    border-radius: 50%;
  }

  .am-switch-yes {
    color: white;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 33%;
    font-size: 11px;
    font-family: Verdana, sans-serif;
    display: none;
    font-weight: bold;
  }

  .am-switch-no {
    color: white;
    position: absolute;
    transform: translate(-50%, -50%);
    top: 50%;
    left: 65%;
    font-size: 11px;
    font-family: Verdana, sans-serif;
    font-weight: bold;
  }

  .am-switch input:checked+ .am-slider .am-switch-yes
  {display: block;}

  .am-switch input:checked + .am-slider .am-switch-no
  {display: none;}

  .am-unset-switch {
    position: relative;
    display: inline-block;
    width: 50px;
    height: 20px;
    border: 1.5px solid #666666;
    border-radius: 30px;
  }

  .am-unset-slider{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #999;
  }

  .am-unset-slider:before {
    position: absolute;
    content: "";
    height: 15px;
    width: 15px;
    bottom: 1px;
    left: 15px;
    background-color: white;
    border: 1px solid #666666;
    border-radius: 30px;
  }

  .am-unset-slider.round {
    border-radius: 34px;
    cursor: pointer;
  }

  .am-unset-slider.round:before {
    border-radius: 50%;
  }

  .am-unset-switch input {
    display: none;
  }

</style>
